import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store/structureDefinitions/cartState';

import { DeliveryMode } from '../store/structureDefinitions/storeState';

const selectStore = (state: RootState) => state.store;
const selectedDeliveryModeOrDefault = (state: RootState) =>
    state.store.deliveryMode || DeliveryMode.homedelivery;
const currentStore = (state: RootState) => state.store.selectedStore;
const currentProductionUnit = (state: RootState) => state.store.productionUnitId;
const currentPickupPointId = (state: RootState) => state.store.pickupPointId;
const isHomeDeliverySelected = createSelector(
    selectStore,
    (store) => store.deliveryMode === DeliveryMode.homedelivery,
);

const isPickupSelected = createSelector(
    selectStore,
    (store) => store.deliveryMode === DeliveryMode.pickup,
);
const hasActiveStoreSelection = createSelector(
    isHomeDeliverySelected,
    isPickupSelected,
    (_isHomeDeliverySelected, _isPickupSelected) =>
        !!_isHomeDeliverySelected || !!_isPickupSelected,
);

const pickupSelected = createSelector(selectStore, isPickupSelected, (_store, _pickupSelected) =>
    _pickupSelected ? { store: _store.selectedStore } : null,
);

const currentProductionUnitOrDefault = createSelector(
    selectedDeliveryModeOrDefault,
    currentProductionUnit,
    (deliveryMode, _currentProductionUnit) => {
        return _currentProductionUnit;
    },
);

export const storeSelectors = {
    selectedDeliveryModeOrDefault,
    currentStore,
    currentProductionUnit: currentProductionUnitOrDefault,
    isHomeDeliverySelected,
    pickupSelected,
    isPickupSelected,
    hasActiveStoreSelection,
    currentPickupPointId,
};
